/**
 * FontSizeExtension — Schriftgroesse als TextStyle-Attribut.
 *
 * Phase 8 Iter 4 (30.05.): Es gibt keine offizielle TipTap-Extension fuer
 * font-size, aber die Community-Implementierung ist klein. Wir setzen einen
 * Mark `textStyle` mit Attribut `fontSize` und rendern es als Inline-`style`.
 *
 * Voraussetzung: `@tiptap/extension-text-style` muss in den Extensions sein —
 * sonst gibt es keinen `textStyle`-Mark in dem wir Attribute haengen koennen.
 *
 * 6 Presets in der Toolbar (Mail-typische Groessen):
 *   12px, 14px, 15px (Default), 17px, 20px, 24px
 */
import { Extension } from '@tiptap/core';

export const FONT_SIZE_PRESETS = [
  { label: '12', value: '12px' },
  { label: '14', value: '14px' },
  { label: '15', value: '' }, // Default — leer = kein Inline-Style → EMAIL_CSS 15px
  { label: '17', value: '17px' },
  { label: '20', value: '20px' },
  { label: '24', value: '24px' },
] as const;

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    fontSize: {
      /** Setzt font-size auf die aktuelle Selection. '' = unset. */
      setFontSize: (size: string) => ReturnType;
      unsetFontSize: () => ReturnType;
    };
  }
}

export const FontSizeExtension = Extension.create({
  name: 'fontSize',

  addGlobalAttributes() {
    return [
      {
        // Mark auf textStyle (von @tiptap/extension-text-style bereitgestellt)
        types: ['textStyle'],
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (el: HTMLElement) => {
              const size = el.style?.fontSize ?? '';
              return size || null;
            },
            renderHTML: (attrs: { fontSize?: string | null }) => {
              if (!attrs.fontSize) return {};
              return { style: `font-size: ${attrs.fontSize}` };
            },
          },
        },
      },
    ];
  },

  addCommands() {
    return {
      setFontSize:
        (size: string) =>
        ({ chain }) => {
          if (!size) {
            return chain().setMark('textStyle', { fontSize: null }).removeEmptyTextStyle().run();
          }
          return chain().setMark('textStyle', { fontSize: size }).run();
        },
      unsetFontSize:
        () =>
        ({ chain }) => {
          return chain().setMark('textStyle', { fontSize: null }).removeEmptyTextStyle().run();
        },
    };
  },
});
